import bfn from './bfn.png'
import uba from './uba.png'
import iTap from './iTap.png'
import kobo from './kobo.png'
import andela from './andela.svg'
import verdant from './verdant.png'
import paystack from './paystack.png'
import terragon from './terragon.png'
import avocademy from './avocademy.png'
import dotcampus from './dotcampus.png'
import flutterwave from './flutterwave.png'
import interswitch from './interswitch.png'

export  const mentorLogos = [
  {name: 'Paystack', icon: paystack,},
  {name: 'Terragon', icon: terragon,},
  {name: 'Flutterwave', icon: flutterwave,},
  {name: 'Dotcampus', icon: dotcampus,},
  {name: 'UBA', icon: uba,},
  {name: 'Andela', icon: andela,},
  {name: 'BFN', icon: bfn,},
  {name: 'Interswitch', icon: interswitch,},
  {name: 'Avocademy', icon: avocademy,},
  {name: 'Verdant DevCore', icon: verdant,},
  {name: 'Kobo60', icon: kobo,},
  {name: 'iTap Solution', icon: iTap,},
]
